<template>
  <ion-page>
    <ion-header :translucent="true">
      <ion-toolbar>
        <ion-buttons slot="start">
          <ion-menu-button color="primary"></ion-menu-button>
        </ion-buttons>
        <ion-title>Request IOU</ion-title>
      </ion-toolbar>
    </ion-header>
    
    <ion-content :fullscreen="true">
      <ion-header collapse="condense">
        <ion-toolbar>
          <ion-title size="large">Request IOU</ion-title>
        </ion-toolbar>
      </ion-header>
    
      <div id="container">
        <ion-item>
          <ion-label position="floating">IOU Type <span class="required">*</span></ion-label>
          <ion-select mode="ios" interface="action-sheet" v-model="iouType">
              <ion-select-option value="Logistics">Logistics</ion-select-option>
              <ion-select-option value="Marketing">Marketing</ion-select-option>
              <ion-select-option value="Admin">Admin</ion-select-option>
              <ion-select-option value="Sales">Sales</ion-select-option>
              <ion-select-option value="Other">Other</ion-select-option>
          </ion-select>
        </ion-item>
        <ion-item>
            <ion-label position="floating">Purpose <span class="required">*</span></ion-label>
            <ion-textarea  v-model="purpose"></ion-textarea>
        </ion-item>
        <ion-item>
            <ion-label position="floating">Amount <span class="required">*</span></ion-label>
            <ion-input type="number"  v-model="amount"></ion-input>
        </ion-item>
        <ion-item>
          <ion-label position="floating">Submit To <span class="required">*</span></ion-label>
          <ion-select mode="ios" interface="action-sheet" v-model="submitTo">
              <ion-select-option v-for="(user,i) of users" :key="i" :value="user.id">{{user.name}}</ion-select-option>
          </ion-select>
        </ion-item>
        <ion-button expand="block" @click="save" color="success">Submit</ion-button>
        
      </div>
    </ion-content>
  </ion-page>
</template>

<script>
import { IonButtons, IonContent, IonHeader, IonMenuButton, IonPage, IonTitle, IonToolbar, IonButton, IonItem, IonLabel, IonInput, IonTextarea, IonSelect, IonSelectOption, alertController} from '@ionic/vue';

export default {
  name: 'Request IOU',
  components: {
    IonButtons,
    IonContent,
    IonHeader,
    IonMenuButton,
    IonPage,
    IonTitle,
    IonToolbar,
    IonButton,
    IonItem,
    IonLabel,
    IonInput,
    IonTextarea,
    IonSelect,
    IonSelectOption
  },
  created(){
    this.$http.get('getUser',).then(response=>{
        this.users=response.data;
    });
  },
  data(){
      return {
        iouType:null,
        users:[],
        submitTo:null,
        amount:null,
        purpose:null
      }
  },
  methods:{
      async save(){
        if(this.purpose=="" || this.purpose==null){
            this.presentAlert("purpose");
            return;
        }
        if(this.amount=="" || this.amount==null){
            this.presentAlert("amount");
            return;
        }
        if(this.submitTo=="" || this.submitTo==null){
            this.presentAlert("Submit to");
            return;
        }
        const data={
            'iou_type':this.iouType,
            'amount':this.amount,
            'purpose':this.purpose,
            'submit_to':this.submitTo,
        };
        data['username'] = window.localStorage.username,
        data['password'] = window.localStorage.password,
      this.$http.post('requestIOU',data).then(response=>{
        if(response.status==200){
            this.purpose=null;
            this.amount=null;
            this.submitTo=null;
            this.iouType=null;
          this.presentResponseAlert('Success','IOU Request submitted successfully');
        }
      });      
    },
      async presentResponseAlert(type,message) {
      const alert = await alertController
        .create({
          header: type+'!',
          // subHeader: 'Subtitle',
          message: message,
          buttons: ['OK'],
        });
      await alert.present();

    },
    async presentAlert(message) {
      const alert = await alertController
        .create({
          header: 'Alert!',
          // subHeader: 'Subtitle',
          message: message+" is required",
          buttons: ['OK'],
        });
      await alert.present();

    },
  }
}
</script>

<style scoped>

#container strong {
  font-size: 20px;
  line-height: 26px;
}

#container p {
  font-size: 16px;
  line-height: 22px;
  color: #8c8c8c;
  margin: 0;
}

#container a {
  text-decoration: none;
}
</style>